var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-item-module personal-module"
  }, [_c('h1', {
    staticClass: "module-title"
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('thumbnail', {
    staticClass: "mt-20",
    attrs: {
      "width": 110,
      "gender": _vm.data.gender === 1 ? 'man' : 'woman'
    }
  }), _vm._v(" "), _c('personal', {
    ref: "personal",
    attrs: {
      "init": _vm.data
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc750bb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/resumeDetail/personalModule.vue
// module id = null
// module chunks = 